import { useSearchParams } from "react-router-dom";
import useDocumentTitle from "../../../shared/customHooks/useDocumentTitle";
import AdminEmailTabs from "../components/AdminEmailTabs";
import "../styles/adminEmailTemplate.css"
//import ContactEditPage from "./ContactEditPage";

const AdminEmailPage = () => {
  useDocumentTitle('Emails')
  const [params] = useSearchParams();
  const mode = params.get("mode");
  const contactId = params.get("id");

  return (
    <div className="row">
      {!mode && <AdminEmailTabs />}

      {/* {mode === "edit" && contactId && (
        <ContactEditPage contactId={contactId} />
      )} */}
    </div>
  );
};

export default AdminEmailPage;